// icons
import { SlBag } from "react-icons/sl";
import { FiMenu } from "react-icons/fi";
// components
import Logo from "../components/Logo";
import SearchForm from "../components/SearchForm";
import CartegoryNavMobile from "./CategoryNavMobile";
import Cart from "../components/Cart";
import ThemeToggle from "../components/ThemeToggle";
import { useContext, useState } from "react";
import { CartContext } from "../context/CartContext";

export default function Header() {
  const { isOpen, setIsOpen, itemsAmount } = useContext(CartContext);
  const [catNavMobile, setCatnavMobile] = useState(false);
  return (
    <header className="bg-canvas border-b border-border py-6 fixed w-full top-0 z-40 lg:sticky xl:mb-[30px]">
      <div className="container mx-auto">
        <div className="flex flex-row gap-4 lg:items-center justify-between mb-4 xl:mb-0">
          {/* menu */}
          <button
            type="button"
            onClick={() => setCatnavMobile(true)}
            aria-label="Open categories menu"
            className="text-3xl xl:hidden cursor-pointer text-ink hover:text-brand transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand rounded">
            <FiMenu />
          </button>

          {/* category nav mobile overlay + panel */}
          {catNavMobile && (
            <div
              onClick={() => setCatnavMobile(false)}
              className="fixed inset-0 bg-black/50 z-40 xl:hidden"
              aria-hidden="true"
            />
          )}
          <div
            className={`${
              catNavMobile ? "left-0" : "-left-full"
            } fixed top-0 bottom-0 z-50 w-full max-w-[340px] transition-all duration-200`}>
            <CartegoryNavMobile setCatnavMobile={setCatnavMobile} />
          </div>

          {/* logo */}
          <Logo />
          {/* searchform - shows only on desktop */}
          <div className=" hidden w-full xl:flex xl:max-w-[734px]">
            <SearchForm />
          </div>
          {/* theme toggle & cart */}
          <div className="flex items-center gap-x-[10px]">
            {/* phone */}
            <div className=" hidden xl:flex uppercase text-muted text-sm mr-2">
              Need help? 123 456 789
            </div>
            <ThemeToggle />
            {/* cart icon */}
            <button
              type="button"
              onClick={() => setIsOpen(!isOpen)}
              aria-label={`Open cart, ${itemsAmount} item${itemsAmount === 1 ? "" : "s"}`}
              aria-haspopup="dialog"
              aria-expanded={isOpen}
              className="relative cursor-pointer text-ink hover:text-brand transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand rounded">
              <SlBag className="text-2xl" />
              {/* amount */}
              {itemsAmount > 0 && (
                <div className="bg-brand text-white absolute w-[18px] h-[18px] rounded-full top-3 -right-1 text-[13px] flex justify-center items-center font-bold tracking-[-0.1em] ring-2 ring-canvas">
                  {itemsAmount}
                </div>
              )}
            </button>

            {/* cart overlay + drawer */}
            {isOpen && (
              <div
                onClick={() => setIsOpen(false)}
                className="fixed inset-0 bg-black/50 z-40"
                aria-hidden="true"
              />
            )}
            <div
              role="dialog"
              aria-label="Shopping cart"
              aria-hidden={!isOpen}
              className={`${
                isOpen ? "right-0" : "-right-full"
              } bg-canvas border-l border-border shadow-xl fixed top-0 bottom-0 w-full z-50 md:max-w-[500px] transition-all duration-300`}>
              <Cart />
            </div>
          </div>
        </div>
        {/* searchform - show on mobile only */}
        <div className="xl:hidden">
          <SearchForm />
        </div>
      </div>
    </header>
  );
}
